import { action, makeObservable, observable } from 'mobx';
import RootStore from '.';
import BaseStore from './BaseStore';
import { saveLocalStorage } from '@/utils/browsers';
import { DevicesScreen, WindowSize } from '@/hooks/useWindowSize';

export default class UIStore extends BaseStore {
    // isOpenSidebar: boolean = getStorage('isOpenSidebar') === 'true';
    isOpenSidebar: boolean = true;
    isOpenSidebarEU: boolean = false;
    isShowScrollToTop: boolean = false;

    contentTop: number | null = null;
    hidePosTop: number | null = null;

    devicesScreen: DevicesScreen = {
        mobile: false,
        desktop: false
    };

    windowSize: WindowSize = {
        width: window.innerWidth,
        height: window.innerHeight
    };

    constructor(rootStore: RootStore) {
        super(rootStore);
        makeObservable(this, {
            devicesScreen: observable,
            windowSize: observable,
            isOpenSidebar: observable,
            isOpenSidebarEU: observable,
            isShowScrollToTop: observable,
            contentTop: observable,
            hidePosTop: observable,
            setOpenSidebar: action.bound,
            setOpenSidebarEU: action.bound,
            setDevicesScreen: action.bound,
            setWindowSize: action.bound
        });
    }

    setOpenSidebar(value?: boolean) {
        if (value === undefined) {
            this.isOpenSidebar = !this.isOpenSidebar;
        } else {
            this.isOpenSidebar = value;
        }
        saveLocalStorage('isOpenSidebar', String(this.isOpenSidebar));
    }

    setOpenSidebarEU(value?: boolean) {
        if (value === undefined) {
            this.isOpenSidebarEU = !this.isOpenSidebarEU;
        } else {
            this.isOpenSidebarEU = value;
        }
        saveLocalStorage('isOpenSidebarEU', String(this.isOpenSidebarEU));
    }

    setDevicesScreen(value: DevicesScreen) {
        this.devicesScreen = value;
    }

    setWindowSize(value: WindowSize) {
        this.windowSize = value;
    }
}
